import { WidgetType } from '@fruitful/types';

import type { ChatMessage } from '../types/ChatTypes';
import { getAssistantDisplayContent } from './reorderAssistantContentParts';

export const isVisibleAssistantContent = (
    message: ChatMessage,
    contentIndex: number,
): boolean => {
    const content = getAssistantDisplayContent(message)[contentIndex];
    if (content == null) {
        return false;
    }

    if (content.type === 'text') {
        return content.text.trim() !== '';
    }

    if (content.type !== 'ui') {
        return false;
    }

    if (content.widget === WidgetType.MultiSelectInput) {
        return false;
    }

    if (content.widget === WidgetType.DraftedMessageButton) {
        return false;
    }

    return true;
};

const getLastVisibleAssistantContentIndex = (message: ChatMessage): number => {
    const displayContent = getAssistantDisplayContent(message);

    for (let index = displayContent.length - 1; index >= 0; index -= 1) {
        if (isVisibleAssistantContent(message, index)) {
            return index;
        }
    }

    return -1;
};

export const getLatestAssistantMessageLogoIconTarget = (
    messages: ChatMessage[],
    isStreaming: boolean,
): { messageId: string; contentIndex: number } | null => {
    if (messages.length === 0) {
        return null;
    }

    const lastMessage = messages[messages.length - 1];

    // While a new turn is in flight, don't leave the logo icon on an earlier message.
    if (isStreaming) {
        if (lastMessage?.role === 'user') {
            return null;
        }

        if (lastMessage?.role === 'assistant' && lastMessage.isError !== true) {
            const contentIndex =
                getLastVisibleAssistantContentIndex(lastMessage);
            if (contentIndex === -1) {
                return null;
            }

            return { messageId: lastMessage.id, contentIndex };
        }

        return null;
    }

    for (let index = messages.length - 1; index >= 0; index -= 1) {
        const message = messages[index];
        if (message?.role !== 'assistant' || message.isError === true) {
            continue;
        }

        const contentIndex = getLastVisibleAssistantContentIndex(message);
        if (contentIndex === -1) {
            continue;
        }

        return { messageId: message.id, contentIndex };
    }

    return null;
};
